import React, { useState } from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";

import { useTranslation } from "react-i18next";
import Hero from "src/components/Hero/Hero";
import EventFinished from "src/components/EventFinished";

const FollowForFreePlay = () => {
  const [viewBtn, setViewBtn] = useState(false);
  const { t, i18n } = useTranslation();

  // Load the promotion content
  const promoData = require(
    `src/locales/${i18n.language}/promotions/egd/followForFreePlay.json`,
  ).followForFreePlay;

  // Helper function to render inline markdown with links
  const renderInlineMarkdown = (text) => {
    // Simple inline markdown parser for **bold** text
    const parts = text.split(/(\*\*.*?\*\*)/g);
    return parts.map((part, index) => {
      if (part.startsWith("**") && part.endsWith("**")) {
        return <strong key={index}>{part.slice(2, -2)}</strong>;
      }
      return part;
    });
  };

  // Helper function to create rewards link
  const createRewardsLink = (text, linkText) => {
    const parts = text.split("{rewardsLink}");
    if (parts.length === 1) return renderInlineMarkdown(text);

    return (
      <>
        {renderInlineMarkdown(parts[0])}
        <Link
          to={t("routes.rewards")}
          style={{
            color: "rgb(38, 89, 154)",
            fontWeight: "bold",
            textDecoration: "underline",
          }}
        >
          {linkText}
        </Link>
        {parts[1] && renderInlineMarkdown(parts[1])}
      </>
    );
  };

  return (
    <PromoDetailDiv>
      <EventFinished scheduleKeyName="followForFreePlay" eventType="promotion" />
      <Hero
        bgImage="promotions/gaming-machines/follow-for-free-play/Follow-For-Free-Play-hero-image-2400x800px.jpg"
        buttonSettings={null}
        image={`promotions/gaming-machines/follow-for-free-play/Follow-For-Free-Play-logo-2400x2400px-${i18n.language}.png`}
        title={promoData.hero.subtitle}
        descriptionBgColor="#0000004d"
      />
      <MainContentDiv>
        <div>
          <p>{renderInlineMarkdown(promoData.content.intro)}</p>

          <p>
            {createRewardsLink(
              promoData.content.rewardsInfo,
              promoData.content.rewardsLinkText,
            )}
          </p>

          <p>{renderInlineMarkdown(promoData.content.reminder)}</p>

          <ContentSectionLink
            href={promoData.content.facebookUrl}
            target="_blank"
            rel="noreferrer"
          >
            {promoData.content.buttonText}
          </ContentSectionLink>
          <button onClick={() => setViewBtn(!viewBtn)}>
            {promoData.terms.buttonText}
            <span></span>
          </button>
          <div className={viewBtn === true ? "ul-active" : undefined}>
            <ul>
              {promoData.terms.items.map((item, index) => (
                <li key={index}>
                  {createRewardsLink(item, promoData.terms.rewardsLinkText)}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </MainContentDiv>
    </PromoDetailDiv>
  );
};
const PromoDetailDiv = styled.div`
  height: fit-content;
  width: 100%;
  z-index: 0;
  background: #e8ebef;
`;

const MainContentDiv = styled.div`
  max-width: 1440px;
  width: 100%;
  margin: 40px auto;
  height: 100%;
  & > div {
    padding: 40px;
    background: var(--white);
    width: 100%;
    height: fit-content;
    & > p {
      font-size: 16px;
      text-align: left;
      padding: 0px 15px;
      color: #555;
    }
    & > button:nth-child(5) {
      width: 100%;
      max-width: 300px;
      border: none;
      height: 40px;
      background-color: #ddd;
      outline: 0;
      color: var(--black);
      margin: 0 auto;
      border-radius: 0;
      padding: 0;
      & > span {
        display: inline-block;
        width: 0;
        height: 0;
        margin-left: 5px;
        vertical-align: middle;
        border-top: 4px dashed;
        border-top: 4px solid;
        border-right: 4px solid transparent;
        border-left: 4px solid transparent;
      }
    }
    & > div:nth-child(6) {
      max-height: 0px;
      overflow: hidden;
      transition: max-height 0.3s ease-in-out;
      & > ul {
        padding: 20px;
        margin: 20px 0 10px 40px;
        list-style-type: disc;
        & > li {
          padding: 3px;
          font-size: 14px;
          color: #555;
        }
      }
      &.ul-active {
        max-height: 350px;
      }
    }
  }
  @media screen and (max-width: 991px) {
    /* start of medium tablet styles */
    & > div {
      & > div:nth-child(6) {
        & > ul {
          margin: 20px;
        }
      }
      & > button:nth-child(5) {
        margin: 0;
      }
    }
  }
  @media screen and (max-width: 479px) {
    /* start of phone styles */
    & > div {
      padding: 20px;
      & > div:nth-child(6) {
        & > ul {
          margin: 20px 0 10px 20px;
          padding-right: 10px;
        }
      }
      & > button:nth-child(5) {
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 0 auto;
      }
    }
  }
`;
const ContentSectionLink = styled.a`
  line-height: 29px;
  height: 50px;
  text-align: center;
  display: block;
  max-width: 300px;
  width: 100%;
  cursor: pointer;
  position: relative;
  z-index: 3;
  transition: all 0.5s;
  position: relative;
  border-radius: 5px;
  padding: 10px 10px;
  margin: 20px auto;
  font-weight: 700;
  font-size: 20px;
  color: var(--white);
  &:hover {
    color: rgb(38, 89, 154);
  }
  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: -1;
    transition: all 0.5s;
    color: var(--white);
    background: rgb(38, 89, 154);
    border-radius: 5px;
  }
  &:hover::before {
    opacity: 0;
    transform: scale(0.5, 0.5);
  }
  &::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
    opacity: 0;
    transition: all 0.5s;
    border: 2px solid rgb(38, 89, 154);
    transform: scale(1.2);
    border-radius: 5px;
  }
  &:hover::after {
    opacity: 1;
    transform: scale(1, 1);
  }
`;
export default FollowForFreePlay;
